import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../core/modules/shared.module';

import { SelectorComponent } from './selector.component';

@NgModule({
  declarations: [
    SelectorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [SelectorComponent]
})
export class SelectorModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/selector/selector.module.ts